











import CTagsInput from '~/components/shared/configurable/form/tag/CTagsInput.vue'
import { Tag } from '~/components/shared/configurable/form/types'
import { computed, defineComponent, ref, toRefs } from '@nuxtjs/composition-api'
import { Ref } from '@vue/composition-api'
import { useClassifiedForm } from '~/compositions/form'
import { formFieldProps } from '~/constants/form'
import { useDep } from '~/compositions/dependency-container'
import FormValidationBuilder from '~/builders/form/FormValidationBuilder'
import { useI18n } from '~/compositions/i18n'
import FieldError from '~/components/car/classifieds/form/fieldsets/fields/FieldError.vue'

export default defineComponent({
  components: { CTagsInput, FieldError },
  props: formFieldProps,
  setup(props) {
    const { specs, name } = toRefs(props)

    const value = ref<any[]>([])

    function onValue(v: Ref<[]>) {
      value.value = (v.value || []).map(tagText => {
        return { text: tagText }
      })
    }

    const { error, isValid, valueChanged } = useClassifiedForm(props, {
      onValue
    })
    const formValidationBuilder = useDep(FormValidationBuilder)
    const { t } = useI18n()

    const placeholder = computed(
      () => specs.value?.placeholder || t('add tags')
    )
    const max = computed(() => specs.value?.max || 10)
    function handleTagsChange(tags: Tag[]) {
      value.value = tags
      formValidationBuilder
        .new(error)
        .arrayMaxLength(max.value, tags)
        .validate()

      valueChanged(
        name.value,
        tags.map(tag => tag.text)
      )
    }

    return { value, error, placeholder, handleTagsChange, isValid }
  }
})
